
export function getEnvProperty(propertyName: string, defaultValue: any): any {
    // @ts-ignore
    const propertyValue = window["env"][propertyName];
    console.log('env value for ' + propertyName + ': ' + propertyValue);
    const resolvedValue = (propertyValue === undefined || propertyValue === '') ? defaultValue : propertyValue;
    console.log('resolved env value for ' + propertyName + ': ' + resolvedValue);
    return resolvedValue;
}
